import React from 'react';
import { NotificationProvider } from '@refinedev/core';
import { Button, notification, Progress } from 'antd';
import { UndoOutlined } from '@ant-design/icons';
import './style.css';
import { NotificationPlacement } from 'antd/es/notification/interface';

type TypeUndoableNotificationProps = {
  notificationKey?: string;
  message: string;
  cancelMutation?: () => void;
  undoableTimeout?: number;
};

const NOTIFICATION_TIME_IN_MS = 6000;

export const handlerNotification = (
  type: 'error' | 'success',
  placement: NotificationPlacement,
  message: string,
  description?: string,
) => {
  notification[type]({
    message,
    description,
    placement,
  });
  setTimeout(() => {
    notification.destroy();
  }, NOTIFICATION_TIME_IN_MS);
};

export const SmartUndoableNotification: React.FC<TypeUndoableNotificationProps> = ({
  notificationKey,
  message,
  cancelMutation,
  undoableTimeout,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '-7px',
    }}
  >
    <Progress
      type='circle'
      percent={(undoableTimeout ?? 0) * 20}
      format={time => time && time / 20}
      width={50}
      strokeColor='#1890ff'
      status='normal'
    />
    <span style={{ marginLeft: 8, width: '100%' }}>{message}</span>
    <Button
      style={{ flexShrink: 0 }}
      onClick={() => {
        cancelMutation?.();
        notification.destroy(notificationKey ?? '');
      }}
      disabled={undoableTimeout === 0}
      icon={<UndoOutlined />}
    ></Button>
  </div>
);

export const smartNotificationProvider: NotificationProvider = {
  open: ({ key, message, description, type, cancelMutation, undoableTimeout }) => {
    switch (type) {
      case 'progress': {
        notification.open({
          key,
          description: (
            <SmartUndoableNotification
              notificationKey={key}
              message={message}
              cancelMutation={cancelMutation}
              undoableTimeout={undoableTimeout}
            />
          ),
          message: null,
          duration: 0,
          closeIcon: <></>,
        });
        break;
      }
      case 'error': {
        handlerNotification(type, 'bottom', message, description);
        break;
      }
      case 'success': {
        if (key === 'success_transaction_confirm' || key === 'success_transaction_cancel') {
          handlerNotification(type, 'bottom', message, description);
        }
        // hide success notification, more info here: https://tracker.yandex.ru/SMART-59
        break;
      }
    }
  },
  close: key => notification.destroy(key),
};
